import { compactMoney } from '@/utilities/Money';

export interface FieldLabel {
  label: string;
  formatter?: (val: string) => string;
}

export const policyFieldLabels: Record<string, FieldLabel> = {
  peFlag: { label: 'Primary / Excess' },
  attachmentOverride: { label: 'Attachment', formatter: compactMoney },
  aggregateLimitOverride: { label: 'Aggregate Limit', formatter: compactMoney },
  occurrenceLimitOverride: { label: 'Occurrence Limit', formatter: compactMoney },
  quotaShareTotalOverride: { label: 'Total Layer Limit', formatter: compactMoney },
  retentionOverride: { label: 'Retention', formatter: compactMoney },
  policyPremiumOverride: { label: 'Premium Total', formatter: compactMoney },
  brokerOverride: { label: 'Broker' },
  sideAOverride: { label: 'Side A' },
  runoffOverride: { label: 'Runoff' },
  underwriterOverride: { label: 'Underwriter' },
  carrierOverride: { label: 'Carrier' },
  syndicateId: { label: 'Lead Syndicate' },

  // Sublimit / subretention audit diffs, which the line history panel now merges in. sublimitID
  // and subretentionID are the item's own row id — they change only on an add or a removal, where
  // the name beside them already says what happened, so they are labelled rather than hidden.
  name: { label: 'Item' },
  limitValue: { label: 'Limit', formatter: compactMoney },
  retentionValue: { label: 'Retention', formatter: compactMoney },
  retentionBasis: { label: 'Basis' },
  sublimitID: { label: 'Sublimit record' },
  subretentionID: { label: 'Subretention record' },
};
